<div class="back-button search-or-back" (click)="backToDashboard()" [class.back-button-disabled]="disabled">
  <i nz-icon nzType="left" class="selector-icon"></i>
  <span class="button">Back</span>
</div>
